import { AnyAction } from "redux";
import { REHYDRATE } from "redux-persist";
import { getNotifications } from "../../actions/notifications";
import { editUserSuccess, refreshTokenSuccess } from "../../reducers/auth";
import { cleanProfileFetching, getBranch, getConcessionary } from "../../actions/profile";
import { initRefreshType, refreshTokenRequest } from "../../actions/auth";
import { getDocumentsTypes } from "../../actions/documents";

export default function userMiddleware(store: any) {
    return (next: any) => async (action: AnyAction) => {
        const result = next(action);
        if (action.type === REHYDRATE && store.getState().auth?.fetchingRefreshToken !== "loading") {
            refreshTokenRequest("first_initialization")(store.dispatch, store.getState);
        }
        if (action.type === refreshTokenSuccess) {
            if(store.getState().auth?.refreshType === "first_initialization"){
                initRefreshType()(store.dispatch);
                getDocumentsTypes()(store.dispatch);
                getNotifications()(store.dispatch, store.getState);
                getConcessionary(store.getState().auth.user?.dealership)(store.dispatch);
                store.getState().auth.user?.profile?.code !== "admin-dealership" && getBranch(store.getState().auth.user?.branch)(store.dispatch);
            }
        }
        if (action.type === editUserSuccess) {
            setTimeout(() => {
                cleanProfileFetching()(store.dispatch);
            },300)
        }
        return result;
    }
};